import React from 'react';
import {Navigate, useLocation} from 'react-router-dom';

interface NavigateKeepingSearchProps {
  to: string;
}

/** Redirection qui conserve la query de l'URL d'origine (`<Navigate>` seul la perd). */
export function NavigateKeepingSearch({to}: NavigateKeepingSearchProps) {
  const {search} = useLocation();
  return <Navigate to={to + search} replace />;
}
